<template>
  <input
    class="default-input"
    :class="input_classes"
    type="text"
    :value="value"
    v-bind="bind_data"
    @input="inputPhone"
  />
</template>

<script>

import phone_mask_list from "../../helpers/phone_mask_list";
export default {
  name: "PhoneInput",
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    input_name: {
      type: String,
      default: 'phone'
    },
    input_classes: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    bind_data() {
      let data = {
        placeholder: this.get_placeholder,
        name: this.input_name,
      }
      if (!this.required) return data
      data['required'] = this.required
      data['title'] = this.get_title
      data['pattern'] = '.{7,20}'
      return data
    },
    get_placeholder() {
      return this.placeholder + (this.required ? '*' : '')
    },
    get_title() {
      return this.value && (!(this.$el?.validity?.valid) || false) ? 'Wrong phone format' : this.get_placeholder
    }
  },
  methods: {
    inputPhone({target}) {
      if (!target.value) {
        return this.$emit('input', '')
      }
      let val = target.value

      let matrix = this.getMatrix(val.replace(/[\s#-)(]/g, ''));
      if (!matrix) {
        matrix = '+###############'
      }

      let i = 0
      val = val.replace(/\D/g, '');

      let new_val = matrix.replace(/(?!\+)./g, (a) => {
        return /[#\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? '' : a
      })
      target.value = new_val
      this.$emit('input', new_val)
    },
    getMatrix(phone) {
      for (let i = 0; phone_mask_list.length > i; i++) {
        let code = phone_mask_list[i].replace(/[\s#]/g, '')
        if (phone.includes(code)) {
          return phone_mask_list[i];
        }
      }
      return ''
    },
  },
}
</script>
